import React from 'react';
import Image from 'next/image';

interface SpeechBubbleProps {
  text: string;
}

export function SpeechBubble(props: SpeechBubbleProps) {
  const { text } = props;

  return (
    <div className="c-speech-bubble -job -bottom-left">
      <Image
        src="/nextjs/images/icons/ic_mega_green.svg"
        alt="Icon"
        width={20}
        height={20}
      />
      <p dangerouslySetInnerHTML={{ __html: text }} />
    </div>
  );
}
